"use client";
import { useState, useRef, useEffect } from "react";
import { useLocale } from "next-intl";
import UniversalLang from "./icons/universal-lang";

const locales = [
  { code: "en", label: "English" },
  { code: "te", label: "తెలుగు" },
  { code: "ta", label: "தமிழ்" },
  { code: "kn", label: "ಕನ್ನಡ" },
];

export default function LanguageSwitcher({ className }) {
  const locale = useLocale();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleChange = (newLocale) => {
    document.cookie = `KUPPAM_CSC_LOCALE=${newLocale}; path=/`;
    window.location.reload();
  };
  return (
    <div className={`relative z-50 ${className}`} ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-center w-[30px] h-[30px] sm:w-10 sm:h-10 lg:w-9 lg:h-9 lg:mt-1 xl:w-10 xl:h-10 xl:mt-1 rounded-full hover:bg-green-3 transition-colors focus:outline-none focus:ring-2 focus:ring-green-1 border border-green-1"
        aria-label="Change language"
      >
        <UniversalLang className="w-9 rounded-full bg-white p-0.5" />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 z-10 border border-gray-200">
          <div className="px-4 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
            Select Language
          </div>
          <ul>
            {locales.map((loc) => (
              <li key={loc.code}>
                <button
                  aria-label="locale code"
                  onClick={() => handleChange(loc.code)}
                  className={`w-full text-left px-4 py-2 text-sm flex items-center transition-colors ${
                    locale === loc.code
                      ? "bg-gray-200 text-green-2 font-medium"
                      : "hover:bg-green-3 text-gray-700"
                  }`}
                >
                  <span className="flex-1">{loc.label}</span>
                  {locale === loc.code && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 text-green-1"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  )}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
